import { useState } from 'react'
import { CurecallModalContainer, CurecallTab } from '@honestica/curecall-ui'
import { useTranslation } from 'react-i18next'
import { ExistingVariableForm } from './existing-variable-form.component'
import { NewVariableForm } from './new-variable-form.component'
import { TVariable } from 'src/types/variable'

interface SelectOrAddVariableModalProps {
  isOpen: boolean
  onCancel: () => void
  onValidate: (variable: TVariable) => void
}

type TTabId = 'existing' | 'new'

export function SelectOrAddVariableModal({ isOpen, onCancel, onValidate }: SelectOrAddVariableModalProps) {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState<TTabId>('existing')

  return (
    <CurecallModalContainer
      closeModalAriaLabel={t('common.actions.cancel')}
      isOpen={isOpen}
      toggle={onCancel}
      title={t('pages.configuration.followups.chatbot.variable-modal.associate-variable-title')}
      dialogClassName="c-w-[700px]"
    >
      <div className="c-flex c-flex-col c-gap-4">
        <div className="c-flex c-gap-[10px] c-border-b c-border-gray-300">
          <CurecallTab
            isActive={activeTab === 'existing'}
            onClick={() => setActiveTab('existing')}
            className="c-flex-1"
            buttonClassName="c-flex-1 c-justify-center"
          >
            {t('pages.configuration.followups.chatbot.variable-modal.use-existing-variable')}
          </CurecallTab>
          <CurecallTab
            isActive={activeTab === 'new'}
            onClick={() => setActiveTab('new')}
            className="c-flex-1"
            buttonClassName="c-flex-1 c-justify-center"
          >
            {t('pages.configuration.followups.chatbot.variable-modal.create-new-variable')}
          </CurecallTab>
        </div>

        {activeTab === 'existing' ? (
          <ExistingVariableForm
            key="existing"
            onCancel={onCancel}
            onValidate={onValidate}
            onSwitchToNewVariable={() => setActiveTab('new')}
          />
        ) : (
          <NewVariableForm key="new" onCancel={onCancel} onValidate={onValidate} />
        )}
      </div>
    </CurecallModalContainer>
  )
}
